import React from 'react';
import { AFFILIATE_URL, trackRegisterClick } from '../utils/tracking';
import { Logo } from './Logo';
const LINKS = [{
  label: 'Mercados',
  href: '#mercados'
}, {
  label: 'Plataforma',
  href: '#plataforma'
}, {
  label: 'Ventajas',
  href: '#ventajas'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Footer() {
  return <footer className="border-t border-line bg-canvas pb-28 pt-14 sm:pb-14" data-id="element-67" data-mp="36q900vzj8gmu">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8" data-id="element-68" data-mp="3uesbtlhsjbjo">
        <div className="flex flex-col gap-8 border-b border-line pb-10 sm:flex-row sm:items-start sm:justify-between" data-id="element-69" data-mp="3ud7czjog16g0">
          <div data-id="element-70" data-mp="3levgx24t5gg6">
            <Logo tone="dark" data-id="element-71" data-mp="3lf5bl30ssbs7" />
            <p className="mt-3 text-[13px] text-ink-500" data-id="element-72" data-mp="3le2icog05x94">
              

            </p>
          </div>

          <nav aria-label="Enlaces del pie" data-id="element-73" data-mp="3qblyxv06am48">
            <ul className="flex flex-wrap gap-x-7 gap-y-3" data-id="element-74" data-mp="29ynlrlrph7ej">
              {LINKS.map(link => <li key={link.href} data-id="element-75" data-mp="2eyt94pqy07qt">
                  <a href={link.href} className="text-[13.5px] text-ink-500 transition-colors duration-200 ease-expo hover:text-brand-600" data-id="element-76" data-mp="2ezut5jpxs4ko">
                    {link.label}
                  </a>
                </li>)}
              <li data-id="element-77" data-mp="3v8hpm2gccspy">
                <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer sponsored" onClick={() => trackRegisterClick('footer', 'Abrir cuenta')} className="text-[13.5px] font-semibold text-brand-600 transition-colors duration-200 ease-expo hover:text-brand-700" data-id="element-78" data-mp="3v91ans1afx87">
                  Abrir cuenta
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="space-y-3 pt-8 text-[12px] leading-relaxed text-ink-400" data-id="element-79" data-mp="cuil89x1gbn1">
          <p data-id="element-80" data-mp="qub9lyl3efru">
            Este sitio es una página independiente de afiliación y no representa el
            sitio oficial de Elyon Markets.
          </p>
          <p data-id="element-81" data-mp="tvcz5qtmo3em">
            Trading involves significant risk and may not be suitable for all
            investors. Past performance is not indicative of future results. Do not
            trade with money you cannot afford to lose.
          </p>
          <p data-id="element-82" data-mp="13sisz6tmm8ij">Datos y gráficos de mercado proporcionados por TradingView.</p>
        </div>
      </div>
    </footer>;
}